import { render } from "./Actives.vue?vue&type=template&id=febeeae2&scoped=true"
import script from "./Actives.vue?vue&type=script&lang=js"
export * from "./Actives.vue?vue&type=script&lang=js"

import "./Actives.vue?vue&type=style&index=0&id=febeeae2&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febeeae2"]])

export default __exports__